import React from "react";

import "./Loader.scss";
const Loader = () => {
    return <div className="loader" id="loader-1"></div>;
};

export default Loader;
